<places-map-layers-controls></places-map-layers-controls>

@if (mapStyles?.length > 1) {
  @if (showStyles) {
    @for (mapStyle of mapStyles; track mapStyle) {
      <div class="map-style" [class.selected]="mapStyle?.name === currentStyle?.name" (click)="changeMapStyle(mapStyle)">
        <div class="circle" [style.background-image]="mapStyle?.iconUrl"></div>
        <!-- add preview image of map -->
        <div class="name">{{mapStyle?.name | translate}}</div>
      </div>
    }
  }
}

